import React from 'react';
import {BrowserRouter as Router} from "react-router";

//context
import { LockerManagementFileUploadProvider } from '@/context/LockerManagementFileUploadContext';
import { LockerManagementContextProvider } from '@/context/LockerManagmentContext';

//components
import LockerManagement from '../elements/LockerManagement/LockerManagement'
import LockerHighlights from  '@/components/elements/LockerManagement/LockerHighlights'
import LockerSecuritySettings from  '@/components/elements/LockerManagement/SecuritySettings';
import LockerNotEnabledError from  '@/components/elements/LockerManagement/LockerNotEnabledError';

import '../../css/lockermanagement.scss';



const LockerManagementPage = ({isLockerEnabled, orgId, isOrgAdmin}: {isLockerEnabled: boolean, orgId: number, isOrgAdmin: boolean}) => (
    <>{
        isLockerEnabled && isOrgAdmin
        ?   <LockerManagementContextProvider>
                <LockerManagementFileUploadProvider>
                    <div id="locker-management">
                        <section id="locker-manangement-container">
                        <Router basename="admin/LockerManagement">
                            <LockerManagement orgId={orgId}/>
                        </Router>
                        </section>
                        <aside id="locker-highlights-and-security">
                            <div className="highlights">
                                <LockerHighlights />
                            </div>
                            <div className="security">
                                <LockerSecuritySettings />
                            </div>
                        </aside>
                    </div>
                </LockerManagementFileUploadProvider>
            </LockerManagementContextProvider>
        : <LockerNotEnabledError {...{isLockerEnabled, isOrgAdmin}} />
        
    }
    </>
  
    
)

export default LockerManagementPage;